/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    
    /** If group 7 matches is UTC, if 8 match is DateTime with Offset, else just a plain old DateTime */
    private static reDt = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(?:(Z)|([+\-])(\d{2}):(\d{2}))?$/;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.jsonParseReviver = (key: string, value: any) => {
            if (typeof value === 'string') {
                const m = ApiClient.reDt.exec(value);
                if (m) {
                    const year = +m[1];
                    const month = +m[2] - 1;
                    const day = +m[3];
                    const hour = +m[4];
                    const minute = +m[5];
                    const secondsAndMs = +m[6];
                    const seconds = Math.floor(secondsAndMs);
                    const milliseconds = secondsAndMs * 1000 % 1000;

                    if (m[7] !== undefined) {
                        // utc date? 
                        return new Date(Date.UTC(year, month, day, hour, minute, seconds, milliseconds));
                    }
                    else if (m[8] !== undefined) {
                        const dt = new Date(year, month, day, hour, minute, seconds, milliseconds);
                        const negationFactor = (m[8] === '-') ? -1 : 1;
                        const originalTimeZoneOffset = (+m[9]) * 60 * negationFactor + +m[10] * negationFactor;
                        const minutesDifference = dt.getTimezoneOffset() + originalTimeZoneOffset;
                        if (minutesDifference !== 0) {
                            dt.setTime(dt.getTime() - minutesDifference * 60 * 1000);
                        }
                        return dt;
                    } {
                        return new Date(year, month, day, hour, minute, seconds, milliseconds);
                    }

                }
            }
            return value;
        };
    }

    /**
     * Creates a new attachment for a specific bonus.
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    postAttachment(bonusId: number, contentType: string | undefined, contentDisposition: string | undefined, headers: { [key: string]: string[]; } | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/Bonuses/{bonusId}/Attachments";
        if (bonusId === undefined || bonusId === null)
            throw new Error("The parameter 'bonusId' must be defined.");
        url_ = url_.replace("{bonusId}", encodeURIComponent("" + bonusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAttachment(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<void>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<void>>><any>_observableThrow(response_);
        }));
    }

    protected processPostAttachment(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Deletes an attachment by id
     * @return Success
     */
    deleteAttachment(attachmentId: number): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/Attachments/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<void>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<void>>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Get attachment by ID.
     * @param thumb (optional) 
     * @return Success
     */
    getAttachment(bonusAttachementId: number, thumb: boolean | undefined): Observable<SwaggerResponse<File>> {
        let url_ = this.baseUrl + "/api/v1/Attachments/{bonusAttachementId}?";
        if (bonusAttachementId === undefined || bonusAttachementId === null)
            throw new Error("The parameter 'bonusAttachementId' must be defined.");
        url_ = url_.replace("{bonusAttachementId}", encodeURIComponent("" + bonusAttachementId));
        if (thumb === null)
            throw new Error("The parameter 'thumb' cannot be null.");
        else if (thumb !== undefined)
            url_ += "thumb=" + encodeURIComponent("" + thumb) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachment(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<File>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<File>>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<SwaggerResponse<File>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <File>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 304) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Modified", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<File>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Gets all Audit TypesA
     * @return Success
     */
    getAuditTypes(): Observable<SwaggerResponse<AuditType[]>> {
        let url_ = this.baseUrl + "/api/v1/AuditTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditTypes(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<AuditType[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<AuditType[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuditTypes(response: HttpResponseBase): Observable<SwaggerResponse<AuditType[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuditType[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AuditType[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getBonusTypes(): Observable<SwaggerResponse<BonusType[]>> {
        let url_ = this.baseUrl + "/api/v1/bonusTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBonusTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBonusTypes(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<BonusType[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<BonusType[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetBonusTypes(response: HttpResponseBase): Observable<SwaggerResponse<BonusType[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BonusType[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BonusType[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getBonusSchedules(): Observable<SwaggerResponse<BonusSchedule[]>> {
        let url_ = this.baseUrl + "/api/v1/bonusSchedules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBonusSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBonusSchedules(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<BonusSchedule[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<BonusSchedule[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetBonusSchedules(response: HttpResponseBase): Observable<SwaggerResponse<BonusSchedule[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BonusSchedule[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BonusSchedule[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getPayoutTypes(): Observable<SwaggerResponse<PayoutType[]>> {
        let url_ = this.baseUrl + "/api/v1/payoutTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayoutTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayoutTypes(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<PayoutType[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<PayoutType[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayoutTypes(response: HttpResponseBase): Observable<SwaggerResponse<PayoutType[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PayoutType[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PayoutType[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Deletes a bonus by bonusId
     * @param bonusId The id of the bonus to delete
     * @return Success
     */
    deleteBonus(bonusId: number): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/bonuses/{bonusId}";
        if (bonusId === undefined || bonusId === null)
            throw new Error("The parameter 'bonusId' must be defined.");
        url_ = url_.replace("{bonusId}", encodeURIComponent("" + bonusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBonus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBonus(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<void>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<void>>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBonus(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Gets full bonus detail by bonusId.
     * @return Success
     */
    getBonusById(bonusId: number): Observable<SwaggerResponse<BonusDetail>> {
        let url_ = this.baseUrl + "/api/v1/bonuses/{bonusId}";
        if (bonusId === undefined || bonusId === null)
            throw new Error("The parameter 'bonusId' must be defined.");
        url_ = url_.replace("{bonusId}", encodeURIComponent("" + bonusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBonusById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBonusById(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<BonusDetail>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<BonusDetail>>><any>_observableThrow(response_);
        }));
    }

    protected processGetBonusById(response: HttpResponseBase): Observable<SwaggerResponse<BonusDetail>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BonusDetail>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BonusDetail>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Returns a page of bonuses based on query parameters.  To include details set projectionOptions.
     * @param orgCodes (optional) 
     * @param bonusStatus (optional) 
     * @param bonusLeaseTypeFilter (optional) 
     * @param bonusTypeIds (optional) 
     * @param recipientNameFilter (optional) 
     * @param createdOnMin (optional) 
     * @param createdOnMax (optional) 
     * @param approvedOnMin (optional) 
     * @param approvedOnMax (optional) 
     * @param paidOnMin (optional) 
     * @param paidOnMax (optional) 
     * @param includeResponsibleOrg (optional) 
     * @param recipientIds (optional) 
     * @param projectDetail (optional) 
     * @param skip (optional) Optional number of records to skip
     * @param top (optional) Optional number of records to be returned
     * @param orderby (optional) Optional order by parameter
     * @param count (optional) Optional count parameter that adds $count as a response header
     * @return Success
     */
    getBonuses(orgCodes: string[] | undefined, bonusStatus: BonusStatus | undefined, bonusLeaseTypeFilter: BonusLeaseTypeFilter | undefined, bonusTypeIds: number[] | undefined, recipientNameFilter: string | undefined, createdOnMin: Date | undefined, createdOnMax: Date | undefined, approvedOnMin: Date | undefined, approvedOnMax: Date | undefined, paidOnMin: Date | undefined, paidOnMax: Date | undefined, includeResponsibleOrg: boolean | undefined, recipientIds: number[] | undefined, projectDetail: boolean | undefined, skip: number | undefined, top: number | undefined, orderby: string | undefined, count: boolean | undefined): Observable<SwaggerResponse<BonusDetail[]>> {
        let url_ = this.baseUrl + "/api/v1/bonuses?";
        if (orgCodes === null)
            throw new Error("The parameter 'orgCodes' cannot be null.");
        else if (orgCodes !== undefined)
            orgCodes && orgCodes.forEach(item => { url_ += "orgCodes=" + encodeURIComponent("" + item) + "&"; });
        if (bonusStatus === null)
            throw new Error("The parameter 'bonusStatus' cannot be null.");
        else if (bonusStatus !== undefined)
            url_ += "bonusStatus=" + encodeURIComponent("" + bonusStatus) + "&";
        if (bonusLeaseTypeFilter === null)
            throw new Error("The parameter 'bonusLeaseTypeFilter' cannot be null.");
        else if (bonusLeaseTypeFilter !== undefined)
            url_ += "bonusLeaseTypeFilter=" + encodeURIComponent("" + bonusLeaseTypeFilter) + "&";
        if (bonusTypeIds === null)
            throw new Error("The parameter 'bonusTypeIds' cannot be null.");
        else if (bonusTypeIds !== undefined)
            bonusTypeIds && bonusTypeIds.forEach(item => { url_ += "bonusTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (recipientNameFilter === null)
            throw new Error("The parameter 'recipientNameFilter' cannot be null.");
        else if (recipientNameFilter !== undefined)
            url_ += "recipientNameFilter=" + encodeURIComponent("" + recipientNameFilter) + "&";
        if (createdOnMin === null)
            throw new Error("The parameter 'createdOnMin' cannot be null.");
        else if (createdOnMin !== undefined)
            url_ += "createdOnMin=" + encodeURIComponent(createdOnMin ? "" + createdOnMin.toJSON() : "") + "&";
        if (createdOnMax === null)
            throw new Error("The parameter 'createdOnMax' cannot be null.");
        else if (createdOnMax !== undefined)
            url_ += "createdOnMax=" + encodeURIComponent(createdOnMax ? "" + createdOnMax.toJSON() : "") + "&";
        if (approvedOnMin === null)
            throw new Error("The parameter 'approvedOnMin' cannot be null.");
        else if (approvedOnMin !== undefined)
            url_ += "approvedOnMin=" + encodeURIComponent(approvedOnMin ? "" + approvedOnMin.toJSON() : "") + "&";
        if (approvedOnMax === null)
            throw new Error("The parameter 'approvedOnMax' cannot be null.");
        else if (approvedOnMax !== undefined)
            url_ += "approvedOnMax=" + encodeURIComponent(approvedOnMax ? "" + approvedOnMax.toJSON() : "") + "&";
        if (paidOnMin === null)
            throw new Error("The parameter 'paidOnMin' cannot be null.");
        else if (paidOnMin !== undefined)
            url_ += "paidOnMin=" + encodeURIComponent(paidOnMin ? "" + paidOnMin.toJSON() : "") + "&";
        if (paidOnMax === null)
            throw new Error("The parameter 'paidOnMax' cannot be null.");
        else if (paidOnMax !== undefined)
            url_ += "paidOnMax=" + encodeURIComponent(paidOnMax ? "" + paidOnMax.toJSON() : "") + "&";
        if (includeResponsibleOrg === null)
            throw new Error("The parameter 'includeResponsibleOrg' cannot be null.");
        else if (includeResponsibleOrg !== undefined)
            url_ += "includeResponsibleOrg=" + encodeURIComponent("" + includeResponsibleOrg) + "&";
        if (recipientIds === null)
            throw new Error("The parameter 'recipientIds' cannot be null.");
        else if (recipientIds !== undefined)
            recipientIds && recipientIds.forEach(item => { url_ += "recipientIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectDetail === null)
            throw new Error("The parameter 'projectDetail' cannot be null.");
        else if (projectDetail !== undefined)
            url_ += "projectDetail=" + encodeURIComponent("" + projectDetail) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBonuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBonuses(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<BonusDetail[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<BonusDetail[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetBonuses(response: HttpResponseBase): Observable<SwaggerResponse<BonusDetail[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BonusDetail[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BonusDetail[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Creates a new bonus.
     * @param body (optional) 
     * @return Success
     */
    postBonus(body: BonusCreationInfo | undefined): Observable<SwaggerResponse<CreatedId>> {
        let url_ = this.baseUrl + "/api/v1/bonuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBonus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBonus(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<CreatedId>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<CreatedId>>><any>_observableThrow(response_);
        }));
    }

    protected processPostBonus(response: HttpResponseBase): Observable<SwaggerResponse<CreatedId>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreatedId>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CreatedId>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param activeOn (optional) 
     * @return Success
     */
    activeemployees(activeOn: Date | undefined): Observable<SwaggerResponse<Employee[]>> {
        let url_ = this.baseUrl + "/api/v1/activeemployees?";
        if (activeOn === null)
            throw new Error("The parameter 'activeOn' cannot be null.");
        else if (activeOn !== undefined)
            url_ += "activeOn=" + encodeURIComponent(activeOn ? "" + activeOn.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveemployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveemployees(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<Employee[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<Employee[]>>><any>_observableThrow(response_);
        }));
    }

    protected processActiveemployees(response: HttpResponseBase): Observable<SwaggerResponse<Employee[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Employee[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Employee[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param activeOn (optional) 
     * @return Success
     */
    activeemployeesummary(activeOn: Date | undefined): Observable<SwaggerResponse<EmployeeSummaryDated[]>> {
        let url_ = this.baseUrl + "/api/v1/activeemployeesummary?";
        if (activeOn === null)
            throw new Error("The parameter 'activeOn' cannot be null.");
        else if (activeOn !== undefined)
            url_ += "activeOn=" + encodeURIComponent(activeOn ? "" + activeOn.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveemployeesummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveemployeesummary(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<EmployeeSummaryDated[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<EmployeeSummaryDated[]>>><any>_observableThrow(response_);
        }));
    }

    protected processActiveemployeesummary(response: HttpResponseBase): Observable<SwaggerResponse<EmployeeSummaryDated[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EmployeeSummaryDated[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<EmployeeSummaryDated[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Gets employee records by id
     * @param empId (optional) 
     * @return Success
     */
    allemployees(empId: number[] | undefined): Observable<SwaggerResponse<Employee[]>> {
        let url_ = this.baseUrl + "/api/v1/allemployees?";
        if (empId === null)
            throw new Error("The parameter 'empId' cannot be null.");
        else if (empId !== undefined)
            empId && empId.forEach(item => { url_ += "empId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllemployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllemployees(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<Employee[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<Employee[]>>><any>_observableThrow(response_);
        }));
    }

    protected processAllemployees(response: HttpResponseBase): Observable<SwaggerResponse<Employee[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Employee[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Employee[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Gets leases
     * @param orgCodes (optional) 
     * @param leaseBonusStatusFilter (optional) 
     * @param customerNameFilter (optional) 
     * @param skip (optional) Optional number of records to skip
     * @param top (optional) Optional number of records to be returned
     * @param orderby (optional) Optional order by parameter
     * @param count (optional) Optional count parameter that adds $count as a response header
     * @return Success
     */
    getLeases(orgCodes: string[] | undefined, leaseBonusStatusFilter: LeaseBonusStatusFilter | undefined, customerNameFilter: string | undefined, skip: number | undefined, top: number | undefined, orderby: string | undefined, count: boolean | undefined): Observable<SwaggerResponse<Lease[]>> {
        let url_ = this.baseUrl + "/api/v1/leases?";
        if (orgCodes === null)
            throw new Error("The parameter 'orgCodes' cannot be null.");
        else if (orgCodes !== undefined)
            orgCodes && orgCodes.forEach(item => { url_ += "orgCodes=" + encodeURIComponent("" + item) + "&"; });
        if (leaseBonusStatusFilter === null)
            throw new Error("The parameter 'leaseBonusStatusFilter' cannot be null.");
        else if (leaseBonusStatusFilter !== undefined)
            url_ += "leaseBonusStatusFilter=" + encodeURIComponent("" + leaseBonusStatusFilter) + "&";
        if (customerNameFilter === null)
            throw new Error("The parameter 'customerNameFilter' cannot be null.");
        else if (customerNameFilter !== undefined)
            url_ += "customerNameFilter=" + encodeURIComponent("" + customerNameFilter) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeases(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<Lease[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<Lease[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetLeases(response: HttpResponseBase): Observable<SwaggerResponse<Lease[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Lease[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Lease[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Gets leases
     * @return Success
     */
    getLease(leaseId: number): Observable<SwaggerResponse<Lease>> {
        let url_ = this.baseUrl + "/api/v1/leases/{leaseId}";
        if (leaseId === undefined || leaseId === null)
            throw new Error("The parameter 'leaseId' must be defined.");
        url_ = url_.replace("{leaseId}", encodeURIComponent("" + leaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLease(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<Lease>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<Lease>>><any>_observableThrow(response_);
        }));
    }

    protected processGetLease(response: HttpResponseBase): Observable<SwaggerResponse<Lease>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Lease>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Lease>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Gets possible duplicates for a lease
     * @return Success
     */
    getLeasePossibleDuplicates(leaseId: number): Observable<SwaggerResponse<Lease[]>> {
        let url_ = this.baseUrl + "/api/v1/leases/{leaseId}/possibleDuplicates";
        if (leaseId === undefined || leaseId === null)
            throw new Error("The parameter 'leaseId' must be defined.");
        url_ = url_.replace("{leaseId}", encodeURIComponent("" + leaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeasePossibleDuplicates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeasePossibleDuplicates(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<Lease[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<Lease[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetLeasePossibleDuplicates(response: HttpResponseBase): Observable<SwaggerResponse<Lease[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Lease[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Lease[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Updates the bonus info for a lease
     * @param body (optional) 
     * @return Success
     */
    postLeaseBonusEligibility(leaseId: number, body: BooleanPrimativePostWrapper | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/leases/{leaseId}/bonusEligibility";
        if (leaseId === undefined || leaseId === null)
            throw new Error("The parameter 'leaseId' must be defined.");
        url_ = url_.replace("{leaseId}", encodeURIComponent("" + leaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLeaseBonusEligibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLeaseBonusEligibility(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<void>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<void>>><any>_observableThrow(response_);
        }));
    }

    protected processPostLeaseBonusEligibility(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Gets all possible orgs.
     * @return Success
     */
    getAllOrgs(): Observable<SwaggerResponse<OrgSummary[]>> {
        let url_ = this.baseUrl + "/api/v1/allOrgs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrgs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrgs(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<OrgSummary[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<OrgSummary[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOrgs(response: HttpResponseBase): Observable<SwaggerResponse<OrgSummary[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrgSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<OrgSummary[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Gets security restricted orgs
     * @return Success
     */
    getOrgs(): Observable<SwaggerResponse<OrgSummary[]>> {
        let url_ = this.baseUrl + "/api/v1/orgs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgs(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<OrgSummary[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<OrgSummary[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrgs(response: HttpResponseBase): Observable<SwaggerResponse<OrgSummary[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrgSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<OrgSummary[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Report for Org statuses.
     * @param startOn (optional) 
     * @param endOn (optional) 
     * @return Success
     */
    orgOverviews(startOn: Date | undefined, endOn: Date | undefined): Observable<SwaggerResponse<OrgOverview[]>> {
        let url_ = this.baseUrl + "/api/v1/orgOverviews?";
        if (startOn === null)
            throw new Error("The parameter 'startOn' cannot be null.");
        else if (startOn !== undefined)
            url_ += "startOn=" + encodeURIComponent(startOn ? "" + startOn.toJSON() : "") + "&";
        if (endOn === null)
            throw new Error("The parameter 'endOn' cannot be null.");
        else if (endOn !== undefined)
            url_ += "endOn=" + encodeURIComponent(endOn ? "" + endOn.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrgOverviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrgOverviews(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<OrgOverview[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<OrgOverview[]>>><any>_observableThrow(response_);
        }));
    }

    protected processOrgOverviews(response: HttpResponseBase): Observable<SwaggerResponse<OrgOverview[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrgOverview[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<OrgOverview[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param isExportDisabled (optional) 
     * @param skip (optional) Optional number of records to skip
     * @param top (optional) Optional number of records to be returned
     * @param orderby (optional) Optional order by parameter
     * @param count (optional) Optional count parameter that adds $count as a response header
     * @return Success
     */
    batches(isExportDisabled: boolean | undefined, skip: number | undefined, top: number | undefined, orderby: string | undefined, count: boolean | undefined): Observable<SwaggerResponse<BatchSummary[]>> {
        let url_ = this.baseUrl + "/api/v1/batches?";
        if (isExportDisabled === null)
            throw new Error("The parameter 'isExportDisabled' cannot be null.");
        else if (isExportDisabled !== undefined)
            url_ += "isExportDisabled=" + encodeURIComponent("" + isExportDisabled) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatches(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<BatchSummary[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<BatchSummary[]>>><any>_observableThrow(response_);
        }));
    }

    protected processBatches(response: HttpResponseBase): Observable<SwaggerResponse<BatchSummary[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BatchSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BatchSummary[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postBatch(body: ProcessBatch | undefined): Observable<SwaggerResponse<BatchResult>> {
        let url_ = this.baseUrl + "/api/v1/batches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBatch(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<BatchResult>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<BatchResult>>><any>_observableThrow(response_);
        }));
    }

    protected processPostBatch(response: HttpResponseBase): Observable<SwaggerResponse<BatchResult>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <BatchResult>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BatchResult>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getBatchDetail(batchId: number): Observable<SwaggerResponse<BatchDetail>> {
        let url_ = this.baseUrl + "/api/v1/batches/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchDetail(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<BatchDetail>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<BatchDetail>>><any>_observableThrow(response_);
        }));
    }

    protected processGetBatchDetail(response: HttpResponseBase): Observable<SwaggerResponse<BatchDetail>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BatchDetail>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BatchDetail>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    patchBatch(batchId: number, body: BatchUpdateModel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/batches/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatchBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatchBatch(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<void>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<void>>><any>_observableThrow(response_);
        }));
    }

    protected processPatchBatch(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Return a list of all application users
     * @return Success
     */
    users(): Observable<SwaggerResponse<UserSummary[]>> {
        let url_ = this.baseUrl + "/api/v1/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<UserSummary[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<UserSummary[]>>><any>_observableThrow(response_);
        }));
    }

    protected processUsers(response: HttpResponseBase): Observable<SwaggerResponse<UserSummary[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<UserSummary[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Returns the detailed information for the current user
     * @return Success
     */
    getCurrentUser(): Observable<SwaggerResponse<UserDetail>> {
        let url_ = this.baseUrl + "/api/v1/users/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<UserDetail>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<UserDetail>>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<SwaggerResponse<UserDetail>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDetail>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<UserDetail>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export interface AccessIndex {
    ruleSource: Rule[] | undefined;
}

export enum AccessType {
    None = "None",
    Creator = "Creator",
    Approver = "Approver",
    Payer = "Payer",
    Viewer = "Viewer",
    Administrator = "Administrator",
}

export interface Attachment {
    bonusAttachementId: number | undefined;
    bonusId: number | undefined;
    description: string | undefined;
    fileType: string | undefined;
    name: string | undefined;
    readonly isImage: boolean;
}

export enum AttachmentType {
    None = "None",
    Optional = "Optional",
    Required = "Required",
}

export enum AuditResultType {
    Failed = "Failed",
    NotApplicable = "NotApplicable",
    NotProcessed = "NotProcessed",
    Success = "Success",
}

export interface AuditType {
    auditTypeId: number;
    name: string | undefined;
}

export interface BaseMetaForm {
    $formType: MetaFormType;
}

export interface BatchDetail {
    batchId: number;
    count: number;
    creatorId: number;
    createdOn: Date;
    isExportDisabled: boolean | undefined;
    lastExportOn: Date | undefined;
    name: string | undefined;
    rewardTypeSummary: RewardTypeSummary[] | undefined;
    payouts: BatchPayout[] | undefined;
}

export interface BatchPayout {
    accrualProfileCode: string | undefined;
    amount: number;
    appliesOn: Date;
    approvedOn: Date;
    approverId: number;
    bonusId: number;
    createdOn: Date;
    creatorId: number;
    companyCode: string | undefined;
    department: string | undefined;
    earningsCode: string | undefined;
    empName: string | undefined;
    fileNumber: string | undefined;
    orgCode: string | undefined;
    paidOn: Date;
    payerId: number;
    payoutId: number;
    payoutTypeId: number;
}

export interface BatchResult {
    batchId: number;
    results: ProcessResult[] | undefined;
}

export interface BatchSummary {
    batchId: number;
    count: number;
    creatorId: number;
    createdOn: Date;
    isExportDisabled: boolean | undefined;
    lastExportOn: Date | undefined;
    name: string | undefined;
    rewardTypeSummary: RewardTypeSummary[] | undefined;
}

export interface BatchUpdateModel {
    isExportDisabled: boolean | undefined;
    lastExportOn: Date | undefined;
    name: string | undefined;
}

export interface BonusAudit {
    auditTypeId: number;
    bonusAuditId: number;
    bonusId: number;
    creatorId: number;
    createdOn: Date;
    message: string | undefined;
    resultType: AuditResultType;
}

export interface BonusCreationInfo {
    bonusTypeId: number;
    leasingActivityId: number | undefined;
    leaseType: LeaseType;
    metaForm: BaseMetaForm;
    orgCode: string | undefined;
    appliesOn: Date | undefined;
    title: string | undefined;
    recipients: Recipient[] | undefined;
    referenceBonusId: number | undefined;
    responsibleOrgCode: string | undefined;
}

export interface BonusDetail {
    appliesOn: Date | undefined;
    bonusId: number;
    bonusTypeId: number;
    bonusTypeCategoryId: number;
    creatorId: number;
    createdOn: Date;
    leasingActivityId: number | undefined;
    orgCode: string | undefined;
    responsibleOrgCode: string | undefined;
    title: string | undefined;
    bonusStatus: BonusStatus;
    leaseType: LeaseType;
    hasFailedAudits: boolean;
    metaForm: BaseMetaForm;
    metaJson: string | undefined;
    payouts: PayoutAmount[] | undefined;
    referenceBonusId: number | undefined;
    attachments: Attachment[] | undefined;
    audits: BonusAudit[] | undefined;
    events: BonusEvent[] | undefined;
    recipients: Recipient[] | undefined;
    relatedBonuses: BonusSummary[] | undefined;
}

export interface BonusEvent {
    createdOn: Date;
    creatorId: number;
    description: string | undefined;
    eventId: number;
    eventType: EventType;
}

export enum BonusLeaseTypeFilter {
    Unknown = "Unknown",
    NonLease = "NonLease",
    WithLease = "WithLease",
    All = "All",
}

export interface BonusSchedule {
    bonusScheduleId: number;
    bonusTypeId: number;
    name: string | undefined;
    orgCode: string | undefined;
    payouts: SchedulePayout[] | undefined;
    sameDayShowAndSignRate: number;
    unitTypeCode: string | undefined;
}

export enum BonusStatus {
    Unknown = "Unknown",
    Unapproved = "Unapproved",
    Approved = "Approved",
    Paid = "Paid",
    Denied = "Denied",
}

export interface BonusSummary {
    appliesOn: Date | undefined;
    bonusId: number;
    bonusTypeId: number;
    bonusTypeCategoryId: number;
    creatorId: number;
    createdOn: Date;
    leasingActivityId: number | undefined;
    orgCode: string | undefined;
    responsibleOrgCode: string | undefined;
    title: string | undefined;
}

export interface BonusType {
    bonusTypeId: number;
    categoryId: number;
    categoryName: string | undefined;
    description: string | undefined;
    earningsCode: string | undefined;
    formType: string | undefined;
    isEditingAmountsAllowed: boolean;
    leaseType: LeaseType;
    name: string | undefined;
    priceType: PriceType;
    isResponsibilityAssigned: boolean;
    attachmentType: AttachmentType;
}

export interface BooleanPrimativePostWrapper {
    value: boolean;
}

export interface CreatedId {
    id: number;
}

export interface Employee {
    accrualProfileCode: string | undefined;
    deptCode: string | undefined;
    email: string | undefined;
    employeeId: number;
    fileNumber: string | undefined;
    hiredOn: Date;
    isFullTime: boolean;
    isSalary: boolean;
    jobTitle: string | undefined;
    name: string | undefined;
    orgCode: string | undefined;
    terminatedOn: Date | undefined;
}

export interface EmployeeSummaryDated {
    accrualProfileCode: string | undefined;
    deptCode: string | undefined;
    email: string | undefined;
    employeeId: number;
    fileNumber: string | undefined;
    hiredOn: Date;
    isFullTime: boolean;
    isSalary: boolean;
    jobTitle: string | undefined;
    name: string | undefined;
    orgCode: string | undefined;
    terminatedOn: Date | undefined;
    isCurrentyTerminated: boolean;
    recordPulledOn: Date;
}

export enum EventType {
    Approved = "Approved",
    Denied = "Denied",
    Paid = "Paid",
}

export interface File {
}

export interface Lease {
    leasingActivityId: number;
    sourceLeaseId: number;
    sourceType: SourceType;
    occurredOn: Date;
    enteredBy: string | undefined;
    agentName: string | undefined;
    customerCode: string | undefined;
    customerName: string | undefined;
    leaseFrom: Date;
    leaseTo: Date;
    rate: number;
    leaseType: LeaseType;
    orgCode: string | undefined;
    unitTypeCode: string | undefined;
    unitCode: string | undefined;
    spaceOption: string | undefined;
    isIneligibleForBonus: boolean;
    isSameDayShowAndSign: boolean;
    createdOn: Date;
    bonusId: number | undefined;
    bonusStatus: LeaseBonusStatusFilter;
    isPossibleDuplicate: boolean | undefined;
}

export enum LeaseBonusStatusFilter {
    Unknown = "Unknown",
    Ineligible = "Ineligible",
    Unapproved = "Unapproved",
    Approved = "Approved",
    Paid = "Paid",
    Denied = "Denied",
    WithBonus = "WithBonus",
    NoBonus = "NoBonus",
    AllEligible = "AllEligible",
    All = "All",
}

export enum LeaseType {
    Unknown = "Unknown",
    New = "New",
    Renewal = "Renewal",
    NonLease = "NonLease",
}

export enum MetaFormType {
    Unknown = "Unknown",
    Referral = "Referral",
}

export interface OrgOverview {
    orgCode: string | undefined;
    leasesWithoutBonus: number;
    nonLeaseBonuses: number;
    unapprovedBonuses: number;
    unpaidBonuses: number;
}

export interface OrgSummary {
    isCommunity: boolean;
    name: string | undefined;
    orgCode: string | undefined;
    payrollDeptPrefix: string | undefined;
    priceType: PriceType;
}

export interface PayoutAmount {
    payoutTypeId: number;
    amount: number;
}

export interface PayoutType {
    defaultRecipientRegex: string | undefined;
    name: string | undefined;
    payoutTypeId: number;
    rewardType: RewardType;
}

export enum PriceType {
    Unknown = "Unknown",
    Jsl = "Jsl",
    Btb = "Btb",
    Hybrid = "Hybrid",
}

export interface ProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
}

export interface ProcessBatch {
    batchName: string | undefined;
    eventType: EventType;
    bonusIds: number[] | undefined;
}

export interface ProcessResult {
    bonusId: number;
    processResultType: ProcessResultType;
    message: string | undefined;
}

export enum ProcessResultType {
    NotRun = "NotRun",
    ValidationFailed = "ValidationFailed",
    Excepted = "Excepted",
    Succeeded = "Succeeded",
}

export interface Recipient {
    recipientId: number;
    empId: number;
    payoutTypeId: number;
    name: string | undefined;
    amount: number;
    description: string | undefined;
    createdOn: Date;
    paidOn: Date | undefined;
    isFullTime: boolean | undefined;
}

export interface ReferralForm {
    $formType: MetaFormType;
    referredEmployeeEmail: string | undefined;
}

export enum RewardType {
    Unknown = "Unknown",
    Monetary = "Monetary",
    PTO = "PTO",
}

export interface RewardTypeSummary {
    totalCount: number;
    rewardType: RewardType;
    totalAmount: number;
}

export interface Rule {
    accessType: AccessType;
    bonusTypeCategoryId: number;
    orgCode: string | undefined;
}

export interface SchedulePayout {
    amount: number | undefined;
    bonusSchedulePayoutId: number;
    payoutTypeId: number | undefined;
    rewardType: RewardType;
}

export enum SourceType {
    Unknown = "Unknown",
    Yardi = "Yardi",
    Entrata = "Entrata",
}

export interface UnknownForm {
    $formType: MetaFormType;
    metaJson: string | undefined;
}

export interface UserDetail {
    userId: number;
    email: string | undefined;
    name: string | undefined;
    access: AccessIndex;
}

export interface UserSummary {
    userId: number;
    email: string | undefined;
    name: string | undefined;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

export interface ExtendedApiResult {
    /** $count from the custom $count header */
    $count?: number;
    /** eTag from the ETag respnse header */
    $eTag?: string;
}

interface ExtendedApiWrapper extends ExtendedApiResult {
    data: any;
}